import { isDefined } from "@clipboard-health/util-ts";
import { Stack } from "@mui/material";
import { Avatar, Text } from "@src/appV2/redesign/system/ui-components";
import pluralize from "pluralize";

import { type InterviewSocialProof } from "../../../../HiringFeed/api/hiringFeed.schema";

const MAX_VISIBLE_AVATARS = 3;
const AVATAR_SIZE = 20;

interface InterviewBookingActivityProps {
  interviewSocialProof: InterviewSocialProof;
}

export function InterviewBookingActivity(props: InterviewBookingActivityProps) {
  const { interviewSocialProof } = props;
  const { totalCount, workers } = interviewSocialProof ?? {};

  const firstWorker = workers.at(0);
  if (totalCount === 0 || !isDefined(firstWorker)) {
    return undefined;
  }

  const visibleWorkers = workers.slice(0, MAX_VISIBLE_AVATARS);

  const socialProofText =
    totalCount === 1
      ? `${firstWorker.firstName} ${firstWorker.lastNameInitial}. recently booked an interview`
      : `${firstWorker.firstName} ${firstWorker.lastNameInitial}. and ${totalCount - 1} ${pluralize("other", totalCount - 1)} recently booked interviews`;

  return (
    <Stack direction="row" alignItems="center" spacing={1}>
      <Stack direction="row">
        {visibleWorkers.map((worker, index) => (
          <Avatar
            key={`${worker.firstName}-${worker.lastNameInitial}-${worker.profileImageUrl?.slice(-10)}`}
            src={worker.profileImageUrl}
            alt={`${worker.firstName} ${worker.lastNameInitial}.`}
            sx={{
              width: AVATAR_SIZE,
              height: AVATAR_SIZE,
              fontSize: 10,
              marginRight: index === visibleWorkers.length - 1 ? 0 : "-6px",
              border: "1px solid white",
            }}
          >
            {`${worker.firstName.charAt(0)}${worker.lastNameInitial.charAt(0)}`}
          </Avatar>
        ))}
      </Stack>
      <Text variant="caption" sx={(theme) => ({ color: theme.palette.text.secondary })}>
        {socialProofText}
      </Text>
    </Stack>
  );
}
